export default "__VITE_ASSET__BdmFUett__"